<template>
  <DataTable
    data-testid="planned-allocation-table"
    :columns="columnsTable"
    :data="tableData"
    show-divider
    :has-interaction="false"
    :status="dataTableStatus"
    @on-sort="sortTable"
  />
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

import { DataTable, DataTableProps } from '@warrenbrasil/nebraska-web';
import { columns } from './columns';
import {
  getPlannedAllocation,
  IPlannedItems
} from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  plannedTable: IPlannedItems[];
  portfolioId: string;
  hasApplied: boolean;
}
const props = defineProps<Props>();

const tableData = ref(props.plannedTable);
const isLoading = ref(false);

const productsLength = computed(() => {
  return props.plannedTable.length;
});

const columnsTable = computed(() => {
  return columns(productsLength.value);
});

const dataTableStatus = computed(() => {
  return isLoading.value
    ? DataTableProps.DataTableStatus.Loading
    : DataTableProps.DataTableStatus.Default;
});

async function sortTable(index: number, isSort: boolean, value: string) {
  isLoading.value = true;

  try {
    const direction = isSort ? 'Ascending' : 'Descending';
    const orderBy = index === -1 ? undefined : value;
    const orderType = index === -1 ? undefined : direction;

    const params = { hasApplied: props.hasApplied, orderBy, orderType };

    const data = await getPlannedAllocation(props.portfolioId, params);

    tableData.value = data.items;
  } finally {
    isLoading.value = false;
  }
}
</script>

<style lang="less" scoped>
:deep(.show-divider&:last-of-type > td) {
  border-bottom: none !important;
}
</style>
